import React, { useState } from 'react';
import Home from './components/Home';
import Highlights from './components/HighlightPage/Highlights';

function App() {
  // State for page routing
  const [currentPage, setCurrentPage] = useState<'home' | 'highlights'>('home');

  // Navigation functions
  const navigateToHighlights = () => {
    setCurrentPage('highlights');
  };

  const navigateToHome = () => {
    setCurrentPage('home');
  };

  // Conditional rendering based on current page
  if (currentPage === 'highlights') {
    return <Highlights onNavigateHome={navigateToHome} />;
  }

  return <Home onNavigateToHighlights={navigateToHighlights} />;
}

export default App;